import React from "react";

const CarRentalBooking = () => {
  return (
    <div className="min-h-screen bg-slate-50 font-sans py-10 lg:py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col lg:flex-row gap-8">
        {/* Left Column: Forms */}
        <div className="lg:w-2/3 space-y-6">
          <h1 className="text-2xl sm:text-3xl font-black text-slate-900 tracking-tight mb-2">
            Secure your rental
          </h1>

          {/* Driver Details Form */}
          <div className="bg-white rounded-[2rem] p-6 sm:p-8 shadow-sm border border-slate-200/60">
            <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2">
              <span className="bg-slate-900 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">
                1
              </span>
              Main Driver Details
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                  First Name (as on License)
                </label>
                <input
                  type="text"
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 outline-none focus:border-blue-500 focus:bg-white transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                  Last Name
                </label>
                <input
                  type="text"
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 outline-none focus:border-blue-500 focus:bg-white transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                  Driver's Age
                </label>
                <select className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 outline-none focus:border-blue-500 focus:bg-white transition-colors">
                  <option>25+</option>
                  <option>21-24 (Underage fee may apply)</option>
                  <option>18-20 (Underage fee may apply)</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                  License Country
                </label>
                <select className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 outline-none focus:border-blue-500 focus:bg-white transition-colors">
                  <option>United States</option>
                  <option>Canada</option>
                  <option>United Kingdom</option>
                  <option>Other</option>
                </select>
              </div>
            </div>
          </div>

          {/* Contact Details Form */}
          <div className="bg-white rounded-[2rem] p-6 sm:p-8 shadow-sm border border-slate-200/60">
            <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2">
              <span className="bg-slate-900 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm">
                2
              </span>
              Contact Information
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                  Email
                </label>
                <input
                  type="email"
                  placeholder="Voucher will be sent here"
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 outline-none focus:border-blue-500 focus:bg-white transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                  Phone Number
                </label>
                <input
                  type="tel"
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 outline-none focus:border-blue-500 focus:bg-white transition-colors"
                />
              </div>
            </div>
          </div>

          <button className="w-full bg-orange-500 hover:bg-orange-600 text-white font-black text-lg py-4 rounded-2xl transition-all shadow-[0_8px_20px_rgb(249,115,22,0.25)] active:scale-[0.98]">
            Continue to Payment →
          </button>
        </div>

        {/* Right Column: Order Summary */}
        <div className="lg:w-1/3">
          <div className="bg-white rounded-[2rem] p-6 sm:p-8 shadow-xl border border-slate-100 sticky top-8">
            <h3 className="text-lg font-bold text-slate-900 mb-4 border-b border-slate-100 pb-4">
              Rental Summary
            </h3>

            <div className="mb-4">
              <div className="font-black text-xl text-slate-900">
                Midsize SUV
              </div>
              <p className="text-sm text-slate-500 font-medium">
                Toyota RAV4 or similar
              </p>
            </div>

            <div className="space-y-4 mb-6">
              <div className="flex flex-col">
                <span className="text-xs font-bold text-slate-400 uppercase">
                  Pick-up
                </span>
                <span className="font-bold text-slate-900 text-sm">
                  Los Angeles Int'l (LAX)
                </span>
                <span className="text-slate-600 text-sm">Oct 15, 10:00 AM</span>
              </div>
              <div className="flex flex-col">
                <span className="text-xs font-bold text-slate-400 uppercase">
                  Drop-off
                </span>
                <span className="font-bold text-slate-900 text-sm">
                  Los Angeles Int'l (LAX)
                </span>
                <span className="text-slate-600 text-sm">Oct 20, 10:00 AM</span>
              </div>
            </div>

            <div className="border-t border-slate-100 pt-4 space-y-3 mb-6">
              <div className="flex justify-between text-sm text-slate-600">
                <span>Car Rental (5 days)</span>
                <span className="font-bold text-slate-900">$345.00</span>
              </div>
              <div className="flex justify-between text-sm text-slate-600">
                <span>Taxes & Fees</span>
                <span className="font-bold text-slate-900">$48.30</span>
              </div>
            </div>

            <div className="border-t border-slate-200 pt-4 flex justify-between items-end">
              <div>
                <span className="block text-xs font-bold text-slate-400 uppercase">
                  Total to pay
                </span>
              </div>
              <span className="text-3xl font-black text-slate-900 tracking-tighter">
                $393.30
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarRentalBooking;
